<template>
  <div id="components-layout-demo-basic">
    <a-layout>
      <a-layout-header>
        <a-affix :offset-top="0">
          <div class="brandbar">
            <div class="logo">
              <i>
                <img :src='img.logo' alt="One Forest Centre">
              </i>
              <span>One Forest Centre</span>
            </div>
            <div class="logo">
              <h1>One Forest Centre <b>|</b> 11615 Forest Central Dr</h1>
              <h3>2,821 SF of Office Space Available in Dallas, TX</h3>
            </div>
          </div>
        </a-affix>
      </a-layout-header>
      <a-layout>
        <a-layout-content>
          <router-view />
        </a-layout-content>
      </a-layout>
      <a-layout-footer>
        <div>
          <p>© 2026 One Forest Centre</p>
        </div>
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      img: {
        logo: require('@/assets/img/logo.png')
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#components-layout-demo-basic {
  text-align: center;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  background: white;
  color: #2c3e50;
}
#components-layout-demo-basic .ant-layout-footer {
  line-height: 1.5;
  background: #63666a;
  color: white;
}
#components-layout-demo-basic .ant-layout-sider {
  background: white;
  color: #2c3e50;
  line-height: 120px;
}
#components-layout-demo-basic .ant-layout-content {
  background: white;
  color: #2c3e50;
  min-height: 120px;
  line-height: 120px;
}
#components-layout-demo-basic > .ant-layout:last-child {
  margin: 0;
}
.icon {
  color: rgba(255, 255, 255, 0.8)!important;
}
.content, .carousel {
  text-align: left;
}
.breadcrumb {
  padding: 10px!important;
}
.ant-layout-header {
  height: auto!important;
  padding: 0!important;
}
.brandbar {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
  .logo {
    border-bottom: none;
    box-shadow: none;
    margin-right: 28px;
  }
}
.logo {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
  line-height: 1;
  background: #fff;
  i {
    width: 40px;
    display: inline-block;
    padding: 0px;
    margin-right: 10px;
  }
  span {
    font-size: 20px;
    font-weight: bold;
  }
  img {
    width: 100%;
    vertical-align: middle;
  }
  h1 {
    font-size: 34px;
    font-weight: bold;
    margin: 0;
    line-height: 1;
    padding: 10px 0;
  }
  b {
    color: rgba(0, 0, 0, 0.25);
  }
  h3 {
    font-size: 24px;
    font-weight: 100;
    font-family: Helvetica,Arial,sans-serif;
  }
}
.bottom {
  line-height: 1;
  text-align: left;
  i {
    width: 40px;
    display: inline-block;
    padding: 0px;
    margin-right: 10px;
  }
  span {
    font-size: 20px;
    font-weight: bold;
  }
  img {
    width: 100%;
    vertical-align: middle;
  }
}
.carousel {
  margin-bottom: 25px;
}
section.map {
  text-align: left;
  padding-bottom: 40px;
  padding-left: 20px;
  padding-right: 20px;
  h2 {
    font-size: 24px;
    border-bottom: 1px solid rgb(221, 221, 221);
    line-height: 2;
    font-weight: bold;
    font-size: 24px;
    text-transform: uppercase;
    font-weight: bold;
    color: rgb(0, 0, 0);
    padding-right: 15px;
    padding-top: 0;
    padding-bottom: 15px;
    line-height: 1.5;
  }
}
section.content {
  text-align: left;
  padding-bottom: 40px;
  padding-left: 20px;
  padding-right: 20px;
  h2 {
    font-size: 24px;
    text-transform: uppercase;
    font-weight: bold;
    color: rgb(0, 0, 0);
    padding-right: 15px;
    padding-top: 0;
    padding-bottom: 15px;
    line-height: 1.5;
  }
  ul.list {
    column-count: inherit;
    column-gap: inherit;
    margin-bottom: -13px!important;
    margin: 10px 0 0 0!important;
    line-height: 1.5;
    padding: 0!important;
    li {
        float: none;
        display: inline-block;
        vertical-align: top;
        line-height: 25px;
        padding: 0 0 15px 20px;
        position: relative;
        font-size: 20px;
        width: 100%!important;
        margin-bottom: 0!important;
        margin-right: 0!important;
        margin-left: 0!important;
        -webkit-column-break-inside: avoid;
        backface-visibility: hidden;
      &::before{
        font-size: 1rem;
        content: "";
        width: 8px;
        height: 8px;
        position: absolute;
        left: 0;
        top: 10px;
        background-color: rgb(207, 0, 0);
        border-radius: 50%;
        color: rgb(207, 0, 0);
        margin-top: -0.1rem;
      }
    }
  }
  p {
    white-space: pre-wrap;
    font-size: 20px;
    font-weight: 100;
    line-height: 32px;
    color: rgb(0, 0, 0);
    -webkit-font-smoothing: antialiased;
    margin: 0;
  }
  dl {
    clear: both;
    width: 100%;
    line-height: 2;
  }
  dt {
    width: 50%;
    font-size: 20px;
    font-weight: 100;
    float: left;
  }
  dd {
    width: 50%;
    font-size: 20px;
    font-weight: bold;
    float: left;
  }
  h5 {
    margin: -5px 0 0!important;
    padding: 0!important;
    font-size: 20px;
    line-height: 20px;
    font-weight: 100;
    color: rgb(0, 0, 0);
  }
}
section.transit {
  font-size: 20px;
  line-height: 2;
  .mt30 {
    margin-top:30px!important;
  }
  .toRight{
    text-align: right;
  }
  i {
    display: inline-block;
    margin-left: 8px;
  }
  img {
    width: 28px;
    height: 28px;
    vertical-align: middle;
  }
  .line {
    border-bottom: 1px solid rgb(229, 229, 229);
  }
}
.anticon.cIcon {
  position: relative;
  top: 3px;
  margin-right: 10px;
  font-size: 10px;
}
.rIcon{
  color: rgb(207, 0, 0)!important;
}
.card {
  border: 1px solid rgb(207, 0, 0)!important;
  border-radius: 5px!important;
  img {
    width: 100%;
    display: block;
  }
  dl {
    clear: both;
    &::after {
      content: '.';
      width: 0;
      height: 0;
      clear: both;
      visibility: hidden;
    }
  }
  dt, dd {
    width: 50%;
    float: left;
  }
  h4 {
    font-size: 28px;
    line-height: 1;
    padding-top: 10px;
    text-indent: 10px;
    vertical-align: top;
    margin-bottom: 0px;
  }
  h3 {
    font-size: 24px;
  }
}
.ant-anchor-ink {
  display: none;
}
.expend {
  display: flex;
  justify-content: space-between;
  margin-top: 0;
  .expendImg {
    width: 100%;
    margin-bottom: 20px;
  }
  ul {
    width: 50%;
    margin: 0;
    list-style-type: none;
  }
  li {
    &::before {
      content: "";
      width: 8px;
      height: 8px;
      position: absolute;
      left: 0;
      top: 10px;
      background-color: rgb(207, 0, 0);
      border-radius: 50%;
    }
    font-size: 18px;
    font-weight: 100;
    position: relative;
    line-height: 25px;
    padding: 0 0 15px 20px;
    vertical-align: top;
  }
}
/* For demo */
.ant-carousel .anticon svg {
  width: 30px!important;
  height: 30px!important;
}
.ant-carousel {
  height:560px;
  position: relative;
}
.ant-carousel .slick-slider {
  text-align: center;
  height: 560px;
  line-height: 560px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel .custom-slick-arrow:before {
  display: none;
}
.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slider h3 {
  color: #fff;
}
.slick-track {
  height: 100%;
}
.ant-carousel img{
  height: 560px;
}
</style>
